import { render, staticRenderFns } from "./FileGroupRecord.vue?vue&type=template&id=4a43c57c&scoped=true&"
import script from "./FileGroupRecord.vue?vue&type=script&lang=js&"
export * from "./FileGroupRecord.vue?vue&type=script&lang=js&"
import style0 from "./FileGroupRecord.vue?vue&type=style&index=0&id=4a43c57c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a43c57c",
  null
  
)

export default component.exports